import $ from 'jquery';

$('table.table--selectable').each(function () {
    const $table = $(this);
    const $text = $table
        .parent('.table--responsive-scroll')
        .addBack()
        .next('.table-actions')
        .find('.table-selected-number');

    if ($text.length > 0) {
        const initialText = $text.html();

        this.addEventListener('fds.table.selectable.updated', event => {
            const selected = event.detail.checkedNumber;
            if (selected === 0) {
                $text.html(initialText).addClass('no-selected');
            }
            else if (selected === 1) {
                $text.html(`1 ${$text.data('singular') ?? 'sag'} valgt`).removeClass('no-selected');
            }
            else {
                $text.html(`${selected} ${$text.data('plural') ?? 'sager'} valgt`).removeClass('no-selected');
            }
        });

        $table
            .find('input[type="checkbox"]:checked')
            .each(function () {
                return this.dispatchEvent(new Event('change'));
            });
    }
});
